"use client";
import { motion } from "framer-motion";

export default function TrustedStats() {
  const stats = [
    { value: "4,560+", label: "Active users", description: "growing their wealth" },
    { value: "10.8 grams", label: "Average gold", description: "holdings per user" },
    { value: "350%", label: "Gold price increase", description: "over 8 years" },
    { value: "100%", label: "Physically backed", description: "and insured" },
  ];

  return (
    <section className="py-12 px-4 bg-white">
      <div className="max-w-7xl mx-auto">
        <motion.h3
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-[32px] md:text-[44px] font-semibold mb-4 md:mb-9 text-center tracking-tight"
        >
          Trusted by Thousands of Investors
        </motion.h3>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {stats.map((stat, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1, duration: 0.5 }}
              className="bg-white border border-gray-200 rounded-xl p-6 hover:shadow-lg transition-shadow"
            >
              <div className="text-2xl sm:text-3xl md:text-4xl font-semibold leading-tight text-primary mb-2">
                {stat.value}
              </div>
              <div className="text-gray-900 mb-1">{stat.label}</div>
              <div className="text-gray-600 text-md">{stat.description}</div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
